import React from 'react';
import PropTypes from 'prop-types';
import './BaseTooltip.module.scss';
import cx from 'classnames';

const BaseTooltip = ({
  show,
  text,
  arrowDirection,
  width,
  children,
  containerProps,
  tooltipStyle,
  fadeIn,
}) => {
  return (
    <div styleName={`tooltip-target ${arrowDirection}`} {...containerProps}>
      {show && (
        <div
          styleName={cx('tooltip-wrapper', { 'fade-in': fadeIn })}
          style={tooltipStyle}
        >
          <div styleName="tooltip-text" style={{ width }}>
            {text}
          </div>
          <div styleName="tooltip-arrow" />
        </div>
      )}
      <div styleName="tooltip-anchor">{children}</div>
    </div>
  );
};

BaseTooltip.propTypes = {
  show: PropTypes.bool,
  text: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  arrowDirection: PropTypes.oneOf(['right', 'left', 'up', 'down']).isRequired,
  width: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  containerProps: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  tooltipStyle: PropTypes.object,
  fadeIn: PropTypes.bool,
};

BaseTooltip.defaultProps = {
  show: false,
  width: '',
  containerProps: {},
  tooltipStyle: {},
  fadeIn: false,
};

export default BaseTooltip;
